<template>
  <!-- 角色授权 -->
  <div class="mainClass">
    <buttonsWrap class="buttonBar">
      <cus-btn type="allSelect" @click="checkAllClick" />
      <cus-btn type="reverseSelect" @click="unCheckAllClick" />
      <cus-btn type="cancelSelect" @click="cancelCheckClick" />
    </buttonsWrap>
    <div class="treeContainer">
      <el-tree
        ref="tree"
        :data="treeData"
        show-checkbox
        node-key="id"
        :default-expanded-keys="defaultExpandedKeys"
        :default-checked-keys="defaultCheckedKeys"
        :props="defaultProps"
        :auto-expand-parent="true"
        :check-on-click-node="false"
        :expand-on-click-node="true"
      >
        <!-- :render-after-expand="false"
        -->
        <!-- <span class="custom-tree-node" slot-scope="{ node, data }"> -->
        <span slot-scope="{ node }" class="custom-tree-node">
          <span style="padding-left:5px;">{{ $t(node.label) }}</span>
        </span>
      </el-tree>
    </div>
    <div class="footer-bar-custom">
      <cus-btn type="cancel" @click="goBack" style="margin-right:50px;"/>
      <cus-btn
        v-if="!isView"
        type="save"
        :loading="saveLoding"
        @click="saveData"
      />
    </div>
  </div>
</template>

<script>
// import store from '@/store/index.js'
import dynamicRoutes from '@/router/dynamicRoute'
import { roleMenuSelect, roleAuthorization } from '@/api/adminManagement.js'

export default {
  components: {},
  props: {
    isView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      saveLoding: false,
      // roleData:{//角色数据
      //   id: "",
      //   roleName: "",
      //   sort: null,
      //   roleDesc: "",
      //   roleStatus: ""
      // },
      roleId: '', // 角色id
      treeNodeType: {// 节点类型
        url: 'url',
        button: 'button'
      },
      buttonCode: {
        scan: 'scan'// 浏览
      },
      treeData: [// 树数据源

      ],
      treeDataDefault: [// 默认树数据源

      ],
      defaultProps: {// 树默认属性
        children: 'children',
        label: 'label'
      },
      defaultExpandedKeys: [], // 树默认展开键集合
      defaultCheckedKeys: []// 树默认选中键集合
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.loadData()
  },
  methods: {
    treeNodeCheck(curNodeData, checkedData) {
      // 当复选框被点击的时候触发
      // nodeData：传递给 data 属性的数组中该节点所对应的对象
      // checkedData：树目前的选中状态对象，包含 checkedNodes、checkedKeys、halfCheckedNodes、halfCheckedKeys 四个属性
      // console.log(curNodeData)
      // console.log(checkedData)

      const checkedNodes = checkedData.checkedNodes// 所有选中的节点集合
      if (checkedNodes.length == 0) {
        // 没有被选中的节点
        return
      }
      const checkedKeys = checkedData.checkedKeys// 所有选中的节点键的集合
      const isCurNodeChecked = (checkedKeys.indexOf(curNodeData.id) >= 0)// 当前节点是否被选中
      if (curNodeData.type == this.treeNodeType.url) {
        // //节点类型是url
        // let isScanDisabled = isCurNodeChecked;//如果全选中则不可编辑浏览按钮，如果全不选中则可以编辑浏览按钮
        // this.setNodeAndChildrenChecked(curNodeData,isCurNodeChecked,false,isScanDisabled);//设置节点和子节点选中状态
      } else if (curNodeData.type == this.treeNodeType.button) {
        // 节点类型是button
        if (curNodeData.code === this.buttonCode.scan) {
          // 浏览按钮，不影响其它按钮
          return
        }
        let count = 0
        let buttonScanNode = null
        for (let i = 0; i < checkedNodes.length; i++) {
          const checkedNode = checkedNodes[i]// 选中的节点
          if (checkedNode.parentid === curNodeData.parentid) {
            // 同一个父节点下的子节点
            count++
            if (checkedNode.code === this.buttonCode.scan) {
              // 浏览按钮
              buttonScanNode = checkedNode
            }
            continue
          }
        }
        if (buttonScanNode != null) {
          // if(count>1){
          //   //选中的节点大于1个，则不可编辑浏览按钮
          //   buttonScanNode.disabled = true;
          // }
          // else{
          //   //选中的节点不大于1个，则可以编辑浏览按钮
          //   buttonScanNode.disabled = false;
          // }
          // this.$refs.tree.setCurrentNode(buttonScanNode);
        } else {
          // 如果选中的节点中没有浏览按钮，则在半选节点中找出浏览按钮，并设置浏览按钮为选中
          const halfCheckedNodes = checkedData.halfCheckedNodes// 半选节点集合
          for (let m = 0; m < halfCheckedNodes.length; m++) {
            const halfCheckedNode = halfCheckedNodes[m]
            if (halfCheckedNode.id === curNodeData.parentid) {
              // 当前节点的父节点
              const curParentChildren = halfCheckedNode.children// 当前父节点的所有子节点
              for (let n = 0; n < curParentChildren.length; n++) {
                const curParentChild = curParentChildren[n]
                if (curParentChild.code === this.buttonCode.scan) {
                  // 浏览按钮
                  buttonScanNode = curParentChild
                  break
                }
              }
            }
          }
          // buttonScanNode.disabled = true;
          // this.$refs.tree.setCurrentNode(buttonScanNode);//默认选中
          this.$refs.tree.setChecked(buttonScanNode, true)// 默认选中
        }
      }
    },
    setNodeAndChildrenChecked(nodeData, isChecked, deep, isScanDisabled) {
      // 设置节点和子节点选中状态
      // nodeData：勾选节点的data，isChecked：节点是否选中，deep：是否设置子节点 ，默认为 false
      // isScanDisabled：浏览按钮是否可编辑，默认undefined，如果为true或者false则赋值给浏览按钮的disabled属性
      deep = (deep == undefined || deep == null) ? false : deep
      this.$refs.tree.setChecked(nodeData, isChecked, deep)// 设置节点选中状态
      const childrenData = nodeData.children// 所有子节点
      if (childrenData == undefined || childrenData == null || childrenData.length == 0) {
        return
      }
      for (let i = 0; i < childrenData.length; i++) {
        const childData = childrenData[i]// 子节点
        if (childData.type === this.treeNodeType.url) {
          // 子节点类型为url
          this.setNodeAndChildrenChecked(childData, isChecked, deep, isScanDisabled)// 设置节点和子节点选中状态
        } else if (childData.type === this.treeNodeType.button) {
          // 子节点类型为button
          if (childData.code === this.buttonCode.scan) {
            // 浏览按钮
            if (isChecked) {
              // 如果是选中状态，则先取消选中
              this.$refs.tree.setChecked(childData, false, deep)// 设置节点选中状态
            }
            if (isScanDisabled === true || isScanDisabled === false) {
              childData.disabled = isScanDisabled
            }
          }
          this.$refs.tree.setChecked(childData, isChecked, deep)// 设置节点选中状态
        }
      }
    },
    saveData() {
      this.saveLoding = true
      const perMenuList = this.getPermissionMenuList()// 获取权限菜单列表
      roleAuthorization(perMenuList)
        .then(result => {
          if (result.code == 200) {
            this.$message({
              type: 'success',
              message: result.message
            })

            this.goBack()
          } else {
            // this.$message({
            //   type: 'error',
            //   message: result.message
            // })
          }
          this.saveLoding = false
        })
        .catch(() => {
          this.saveLoding = false
        })
    },
    getPermissionMenuList() {
      // 获取权限菜单数据
      const perMenuList = []// 权限菜单列表
      const roleId = this.roleId// 角色id
      const menuUrlAddedList = []// 已添加的url集合

      // (leafOnly, includeHalfChecked) 接收两个 boolean 类型的参数：
      // 1. 是否只是叶子节点，默认值为 false 2. 是否包含半选节点，默认值为 false
      // 只获取了叶子节点，即树的最终一层的节点
      const treeCheckedNodes = this.$refs.tree.getCheckedNodes(true)

      for (let i = 0; i < treeCheckedNodes.length; i++) {
        const treeCheckNode = treeCheckedNodes[i]// 选中的节点
        const nodeType = treeCheckNode.type// 节点类型
        let perMenuItem// 权限菜单项
        if (menuUrlAddedList.indexOf(treeCheckNode.url) >= 0 || menuUrlAddedList.indexOf(treeCheckNode.parenturl) >= 0) {
          // 已添加过的url或parenturl，则跳过
          continue
        }

        if (nodeType === this.treeNodeType.url) {
          // 节点类型是链接，则直接添加进权限菜单列表中
          perMenuItem = { roleId: roleId, url: treeCheckNode.url }
          perMenuList.push(perMenuItem)
          menuUrlAddedList.push(perMenuItem.url)
          continue
        } else if (nodeType === this.treeNodeType.button) {
          // 节点类型是按钮
          // 只要有按钮被选中，则浏览按钮必须有权限，如果浏览按钮未被选中，则添加浏览按钮到按钮权限集合中
          perMenuItem = { roleId: roleId, url: treeCheckNode.parenturl }
          const perMenuButtons = []
          let isScanChecked = false// 浏览按钮是否选中
          for (let m = 0; m < treeCheckedNodes.length; m++) {
            const nodeButton = treeCheckedNodes[m]// 按钮
            if (perMenuItem.url != undefined && perMenuItem.url != null && nodeButton.parenturl === perMenuItem.url) {
              const perMenuButton = { code: nodeButton.code }// 有权限的按钮
              perMenuButtons.push(perMenuButton)
              if (!isScanChecked && nodeButton.code === this.buttonCode.scan) {
                // 浏览按钮被选中
                isScanChecked = true
              }
            }
          }
          if (!isScanChecked) {
            // 浏览按钮未被选中
            perMenuButtons.splice(0, 0, { code: this.buttonCode.scan })// 添加浏览按钮
          }
          perMenuItem.buttons = perMenuButtons
          perMenuList.push(perMenuItem)
          menuUrlAddedList.push(perMenuItem.url)
          continue
        }
      }

      // //菜单权限数据结构
      // [
      //   {
      //     roleId:"1",//角色id
      //     url:"/role",//路由地址
      //     buttons:[//按钮集合
      //       {
      //         code:"scan"//按钮编号
      //       },
      //       {
      //         code:"add"
      //       }
      //     ]
      //   }
      // ]
      // console.log(perMenuList)
      return perMenuList
    },
    getTreeNodesAll(leafOnly) {
      // 获取所有的节点集合
      // leafOnly是否只是叶子节点，默认值为 false
      leafOnly = leafOnly == undefined || leafOnly == null ? false : leafOnly
      const treeData = this.treeData
      const treeNodes = []
      this.getTreeNodes(treeData, treeNodes, leafOnly)
      return treeNodes
    },
    getTreeNodes(treeData, treeNodes, leafOnly) {
      // 获取树节点集合
      // treeData：树数据，treeNodes：选中的节点集合，leafOnly：是否只是叶子节点，默认值为 false
      leafOnly = leafOnly == undefined || leafOnly == null ? false : leafOnly
      treeNodes = treeNodes == undefined || treeNodes == null ? [] : treeNodes
      if (treeData != undefined && treeData != null && treeData.length > 0) {
        for (let i = 0; i < treeData.length; i++) {
          const treeItem = treeData[i]
          const treeItemNew = Object.assign({}, treeItem)
          if (
            leafOnly &&
            (treeItem.children == undefined ||
              treeItem.children == null ||
              treeItem.children.length == 0)
          ) {
            // 只是叶子节点，没有children时才添加节点
            treeNodes.push(treeItemNew)
          } else if (!leafOnly) {
            // 不只是叶子节点，则添加所有节点
            treeNodes.push(treeItemNew)
          }
          if (
            treeItem.children != undefined &&
            treeItem.children != null &&
            treeItem.children.length > 0
          ) {
            // 有children，则递归添加
            this.getTreeKeys(treeItem.children, treeNodes, leafOnly)
          }
        }
      }

      return treeNodes
    },
    getTreeKeysAll(leafOnly) {
      // 获取树中所有的键集合
      // leafOnly是否只是叶子节点，默认值为 false
      leafOnly = leafOnly == undefined || leafOnly == null ? false : leafOnly
      const treeData = this.treeData
      const treeKeys = []
      this.getTreeKeys(treeData, treeKeys, leafOnly)
      return treeKeys
    },
    getTreeKeys(treeData, treeKeys, leafOnly) {
      // 获取树节点键集合
      // treeData：树数据，treeKeys：选中的节点key集合，leafOnly：是否只是叶子节点，默认值为 false
      leafOnly = leafOnly == undefined || leafOnly == null ? false : leafOnly
      treeKeys = treeKeys == undefined || treeKeys == null ? [] : treeKeys
      if (treeData != undefined && treeData != null && treeData.length > 0) {
        for (let i = 0; i < treeData.length; i++) {
          const treeItem = treeData[i]
          if (
            leafOnly &&
            (treeItem.children == undefined ||
              treeItem.children == null ||
              treeItem.children.length == 0)
          ) {
            // 只是叶子节点，没有children时才添加节点
            treeKeys.push(treeItem.id)
          } else if (!leafOnly) {
            // 不只是叶子节点，则添加所有节点
            treeKeys.push(treeItem.id)
          }
          if (
            treeItem.children != undefined &&
            treeItem.children != null &&
            treeItem.children.length > 0
          ) {
            // 有children，则递归添加
            this.getTreeKeys(treeItem.children, treeKeys, leafOnly)
          }
        }
      }

      return treeKeys
    },
    checkAllClick() {
      // 全选
      const treeKeys = this.getTreeKeysAll()// 获取树中所有的键
      this.$refs.tree.setCheckedKeys(treeKeys)// 设置选中的键
    },
    unCheckAllClick() {
      // 反选
      // console.log(this.$refs.tree.getCheckedNodes(false,true))
      // this.$refs.tree.getCheckedNodes(false,true)//(leafOnly, includeHalfChecked) 接收两个 boolean 类型的参数，1. 是否只是叶子节点，默认值为 false 2. 是否包含半选节点，默认值为 false
      const treeKeys = this.getTreeKeysAll(true)// 获取树中所有的键
      const checkedKeys = this.$refs.tree.getCheckedKeys(true)// (leafOnly) 接收一个 boolean 类型的参数，若为 true 则仅返回被选中的叶子节点的 keys，默认值为 false
      for (let i = 0; i < checkedKeys.length; i++) {
        const index = treeKeys.indexOf(checkedKeys[i])
        if (index >= 0) {
          treeKeys.splice(index, 1)
          continue
        }
      }
      this.$refs.tree.setCheckedKeys(treeKeys)
    },
    cancelCheckClick() {
      // 取消选择
      this.$refs.tree.setCheckedKeys([])
    },
    goBack() {
      // 返回
      this.$router.push({ name: 'roleList' })
    },
    loadData() {
      // 加载数据
      const roleId = this.$route.query.id
      this.roleId = roleId// 角色id
      roleMenuSelect(roleId).then(result => {
        if (result.code == 200) {
          const menuAllList = dynamicRoutes// 所有菜单列表
          const permissionList = result.data // 有权限菜单路由列表
          const treeCheckedKeys = []// 选中的树节点
          this.treeData = this.getTreeData(menuAllList, permissionList, treeCheckedKeys)// 获取菜单树数据
          this.treeDataDefault = Object.assign({}, this.treeData)// 默认菜单树数据
          // this.$refs.tree.setCheckedKeys(treeCheckedKeys);//设置选中节点
          this.defaultCheckedKeys = treeCheckedKeys// 树默认选中键集合
          this.defaultExpandedKeys = treeCheckedKeys// 树默认展开键集合
        } else {
          // this.$message({
          //   type: 'error',
          //   message: result.message
          // })
        }
      })
        .catch(() => {
          // this.$message({
          //   type: "error",
          //   message: "获取信息失败"
          // });
        })
    },
    getTreeData(menuAllList, permissionList, treeCheckedKeys, treeParent) {
      // 获取菜单树数据
      // menuAllList：所有菜单，menuPerList：有权限的菜单，treeCheckedKeys：设置树中选中的节点，treeParent：树中的父节点，可为空
      const treeData = []// 权限树数据
      for (let i = 0; i < menuAllList.length; i++) {
        const menuItem = menuAllList[i]// 菜单项
        const treeItem = { id: menuItem.path, label: menuItem.meta.title, url: menuItem.path, type: this.treeNodeType.url }// 菜单树项
        const menuChildren = menuItem.children// 子菜单
        const menuButtons = menuItem.meta.buttons// 按钮集合
        let permissionItem = null// 有权限的菜单项
        // let menuPerChildren = null;//有权限的菜单项的子菜单
        let menuPerButtons = null// 有权限的按钮集合
        const routeNameParent = menuItem.meta.routeNameParent// 父路由名称
        let isPerUrl = false// 是否有权限的路径

        if (routeNameParent != undefined && routeNameParent != null && routeNameParent !== '') {
          // 有父路由名称，则跳过
          continue
        }
        if (treeParent != undefined && treeParent != null) {
          treeItem.parentid = treeParent.id// 父节点id
          treeItem.parenturl = treeParent.url// 父节点id
        }
        if (permissionList != undefined && permissionList != null && permissionList.length > 0) {
          // 判断当前菜单项是否为有权限的菜单项
          for (let m = 0; m < permissionList.length; m++) {
            const perItemTemp = permissionList[m]
            if (menuItem.path === perItemTemp.url) {
              permissionItem = perItemTemp
              // menuPerChildren = permissionItem.children;
              menuPerButtons = permissionItem.buttons
              permissionList.splice(m, 1)
              isPerUrl = true// 有权限的路径
              break
            }
          }
        }
        if (menuButtons != undefined && menuButtons != null && menuButtons.length > 0) {
          // 按钮集合，转化为树的子项节点
          menuPerButtons = (menuPerButtons == undefined || menuPerButtons == null) ? [] : menuPerButtons
          const treeChildren = []
          for (let n = 0; n < menuButtons.length; n++) {
            const menuButton = menuButtons[n]// 按钮项
            if (menuButton.isShow == false) {
              // 不显示，则跳过
              continue
            }
            const treeChild = { id: menuButton.code + '_' + treeItem.id, 
              label: 'button.' + menuButton.code,//menuButton.name,
              code: menuButton.code, type: this.treeNodeType.button,
              parentid: treeItem.id, parenturl: treeItem.url }
            // if(menuButton.code ===this.buttonCode.scan&&menuPerButtons.length>0){
            //   //如果存在有权限的按钮，则默认有浏览权限
            //   treeCheckedKeys.push(treeChild.id);//有权限的按钮id添加到选中节点集合
            //   continue;
            // }
            for (let k = 0; k < menuPerButtons.length; k++) {
              const menuPerButton = menuPerButtons[k]// 有权限的按钮项
              if (menuButton.code === menuPerButton.code) {
                treeCheckedKeys.push(treeChild.id)// 有权限的按钮id添加到选中节点集合
                break
              }
            }

            treeChildren.push(treeChild)// 添加到树的子节点集合中
          }
          treeItem.children = treeChildren// 树节点的子节点集合
        } else if (menuChildren != undefined && menuChildren != null && menuChildren.length > 0) {
          // 子菜单
          treeItem.children = this.getTreeData(menuChildren, permissionList, treeCheckedKeys, treeItem)
        } else if (isPerUrl && (menuChildren == undefined || menuChildren == null || menuChildren.length == 0)) {
          // 有权限的路径，并且没有子项，则该项就是最终子项，要被选中
          treeCheckedKeys.push(treeItem.id)// 添加到权限集合中
        }

        treeData.push(treeItem)// 添加到菜单树中

        // 树数据结构
        // id: 1,
        // label: "二级 1-1",
        // code:"32232",//自定义的字段
        // children: [
        //    {
        //      id: 9,
        //      code:"322321",//自定义的字段
        //      parentid:"1",//自定义的字段
        //      label: "三级 1-1-1",
        //      disabled:false
        //    }
        // ]
      }

      return treeData
    }
  }
}
</script>
<style scoped lang="scss">
.mainClass {
  min-width: 400px;
  height: 100%;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 1);
  padding: 0 20px;
}

.buttonBar{
  height: 70px;
  margin-top: 20px;
  // margin-bottom: 5px;
}

.treeContainer {
  padding: 10px;
  min-height: 200px;
  height: 50%;//calc(100% - 200px);
  overflow: auto;
  border: 1px solid rgb(197, 197, 216);
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 1);
  flex-grow: 1;
}

/* .footer-custom{
  margin-top:20px;
  margin-bottom:10px;
} */
</style>
